import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Briefcase, ExternalLink, Radio } from 'lucide-react';
import { ListenModal } from '../components/ListenModal';
import axios from 'axios';
import { API_URL } from '../utils/apiUrl';
import { SEOHead } from '../components/SEOHead';
import './Guests.css';

export const Guests = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedEpisode, setSelectedEpisode] = useState(null);
  const [guests, setGuests] = useState([]);
  const [episodes, setEpisodes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      setLoading(true);
      const [guestsRes, episodesRes] = await Promise.all([
        axios.get(`${API_URL}/api/cms/guests`),
        axios.get(`${API_URL}/api/cms/episodes`)
      ]);
      setGuests(guestsRes.data);
      setEpisodes(episodesRes.data);
    } catch (err) {
      console.error('Error fetching data:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleListenClick = (e, episode) => {
    e.preventDefault();
    e.stopPropagation();
    setSelectedEpisode(episode);
    setIsModalOpen(true);
  };

  return (
    <div className="guests-page">
      <SEOHead
        title="Guests"
        description="CEOs, entrepreneurs, athletes, and innovators — meet the guests who joined Golf Nuts to share their golf stories and business insights."
        path="/guests"
      />
      <div className="guests-hero">
        <div className="container">
          <h1 className="display-medium">Our Guests</h1>
          <p className="hero-subtitle-text">
            CEOs, entrepreneurs, athletes, and innovators sharing their golf stories and business insights.
          </p>
        </div>
      </div>

      <div className="container guests-content">
        <div className="guests-grid-page">
          {guests.map((guest) => {
            // Find episodes where this guest is tagged
            const guestEpisodes = episodes.filter(ep => ep.guests && ep.guests.includes(guest.id));
            const hasEpisodes = guestEpisodes.length > 0;
            
            return (
              <div key={guest.id} className="guest-profile-wrapper">
                <Link to={`/guests/${guest.id}`} className="guest-profile-card hover-lift">
                  <div className="guest-image-container">
                    <img src={guest.image} alt={guest.name} className="guest-profile-image" />
                    {hasEpisodes && (
                      <span className="guest-page-episode-button">
                        <Radio size={18} />
                        <span>View Episodes ({guestEpisodes.length})</span>
                      </span>
                    )}
                  </div>
                  <div className="guest-profile-info">
                    <h2 className="heading-2">{guest.name}</h2>
                    <div className="guest-role-company">
                      <Briefcase size={18} />
                      <div>
                        <p className="guest-role-text">{guest.role}</p>
                        <p className="guest-company-text">{guest.company}</p>
                      </div>
                    </div>
                    <p className="body-medium guest-bio-preview">{guest.bio}</p>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
      </div>

      {/* CTA Section */}
      <section className="guest-cta-section">
        <div className="container">
          <div className="guest-cta-card">
            <h2 className="heading-1">Want to be a Guest?</h2>
            <p className="body-large">
              We're always looking for compelling stories and unique perspectives on golf and business. 
              If you have a story to share, we want to hear from you.
            </p>
            <Link to="/contact" className="btn-accent btn-large">
              Get in Touch
              <ExternalLink size={20} />
            </Link>
          </div>
        </div>
      </section>

      {/* Listen Modal */}
      <ListenModal 
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)} 
        episode={selectedEpisode}
      />
    </div>
  );
};
